import { ConstellationInFilter } from '@apeiron/star'
import { NextImage } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const Container = styled(Box)`
  min-height: 90px;
  color: #ffffff;
  display: flex;
  gap: 15px;
  padding: 7px 15px;
`

const Image = styled(NextImage)`
  width: 100px;
  aspect-ratio: 1.3;
  object-fit: contain;
`

const InfoBox = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
`

const ConstellationText = styled(Typography)`
  font-size: 12px;
  line-height: 12px;
  font-weight: 300;
  color: #333333;

  strong {
    font-weight: 500;
  }

  .Mui-focused & {
    color: #ffffff;
  }
`

const StarConstellationItem: FC<Props> = (props: Props) => {
  const { className, constellation } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <Image className='Custom-Image' src={constellation.image} />
      <InfoBox className='Custom-Info-Box'>
        <ConstellationText>
          <Trans>
            {t('star.constellation.list.name', { name: constellation.name })}
          </Trans>
        </ConstellationText>
        <ConstellationText>
          <Trans>
            {t('star.constellation.list.galaxy_name', {
              name: constellation.galaxy.name
            })}
          </Trans>
        </ConstellationText>
        <ConstellationText>
          <Trans>
            {t('star.constellation.list.type', {
              type: constellation.type.name
            })}
          </Trans>
        </ConstellationText>
        <ConstellationText>
          <Trans>
            {t('star.constellation.list.star_count', {
              count: constellation.numberOfStars
            })}
          </Trans>
        </ConstellationText>
      </InfoBox>
    </Container>
  )
}

type Props = {
  className?: string
  constellation: ConstellationInFilter
}

export default StarConstellationItem
